import { all } from 'redux-saga/effects'
import createSagaMiddleware from 'redux-saga'

import watchPromotions from '../../modules/Promotions/sagas'
import watchAuth from '../../modules/Auth/sagas'
import watchPushNotifications from '../../modules/PushNotifications/sagas'
import watchStores from '../../modules/stores/sagas'
import watchProducts from '../../modules/Products/sagas'
import watchCommon from '../../modules/Common/sagas'
import watchOrders from '../../modules/orders/sagas'

export const sagaMiddleware = createSagaMiddleware()

export default function* rootSaga() {
    yield all([
        watchCommon(),
        watchAuth(),
        watchPromotions(),
        watchPushNotifications(),
        watchStores(),
        watchProducts(),
        watchOrders(),
    ])
}
